import * as React from 'react';

import * as _ from 'lodash';

export type Preferences = Readonly<Partial<{
    dataAccessTab: string;
    entityId: string;
    layoutId: string;
    contractId: string;
    tableId: string;
    configurationEntityId: string;
    configurationLayoutId: string;
}>>

export const PreferencesContext = React.createContext<[ Preferences, React.Dispatch<React.SetStateAction<Readonly<Partial<Preferences>>>> ] | null>(null);

export interface PreferencesProviderProps {
}
export function PreferencesProvider({ children }: React.PropsWithChildren<PreferencesProviderProps>) {
    const state = React.useState<Preferences>(loadPreferences());
    React.useEffect(() => {
        setPreferences(state[0]);
    }, [ state[0] ]);

    return (
        <PreferencesContext.Provider value={state}>
            {children}
        </PreferencesContext.Provider>
    )
}
export function usePreferences() {
    const state = React.useContext(PreferencesContext);
    if (!state)
        throw new Error('No preferences provider declared');

    return state;
}

function loadPreferences(): Preferences {
    const content = window.localStorage.getItem('gnosis.preferences');
    if (!content)
        return {};

    return JSON.parse(content);
}
function setPreferences(preferences: Preferences) {
    window.localStorage.setItem('gnosis.preferences', JSON.stringify(preferences));
}